import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
@Component({
    selector: 'app-body-weight-record',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './body-weight-record.component.html',
    styleUrl: './body-weight-record.component.scss'
})
export class BodyWeightRecordComponent {
    @Input() placement: any = null;
    @Input() medication: any = null;
    @Input() averageWeight: any = null;
    @Input() odoAverageweights: any = null;
    weightUnit: string = 'g';
}
